export default "__VITE_ASSET__CvkkZ2Bt__"